<template>
  <div class="p-3 bg-white">
    <shared-project-add
      @addProjectSuccess="addProjectSuccess"
      :progressStatusOptions="progressStatusOptions"
      :userOptions="userOptions"
    ></shared-project-add>

    <div class="text-center">
      <vs-button id="addProjectButton" class="m-2" color="primary" type="filled" @click.prevent="addProject">{{ $t('save') }}</vs-button>
      <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancelAddProject">{{ $t('cancel') }}</vs-button>
    </div>
  </div>
</template>

<script>
import Project from '@/models/Project'
import SharedProjectAdd from '@/views/Shared/Projects/Add'
import { EventBus } from '@/../eventbus'

export default {
  name: 'Window.Project.Add',
  components: {
    SharedProjectAdd
  },
  data () {
    return {
      progressStatusOptions: [],
      userOptions: []
    }
  },
  mounted () {
    this.loadProjects()
  },
  methods: {
    async loadProjects () {
      const response = await Project.all()
      this.progressStatusOptions = response.data.meta.options.progressStatuses
      this.userOptions = response.data.meta.options.users
    },
    addProject () {
      EventBus.$emit('initAddProject')
    },
    addProjectSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_project_table')
      window.close()
    },
    cancelAddProject () {
      this.$windowOpenerHelper.notifyOpener('reload_project_table')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
